<template>
	<span class="m-subheader__daterange" :id="pickerId" :style="rangeStyle">
		<span class="m-subheader__daterange-label">
			<span class="m-subheader__daterange-title"></span>
			<span class="m-subheader__daterange-date m--font-brand"></span>
		</span>
		<a href="javascript:;" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
			<i class="la la-angle-down"></i>
		</a>
	</span>
</template>

<script>
import moment from 'moment';

export default {
    props: ['pickerId'],

    data(){
        return {
            "rangeStyle": {
                "border-radius": "2rem",
                "padding": "5px",
                "background": "#f8f8fb",
                "display": "inline-block"
            }
        }
    },

    mounted () {
        this.initDateRangePicker();
        moment.locale('vi');
    },

    methods: {
        initDateRangePicker: function(){
        	if ($("#"+this.pickerId).length == 0) {
	            return;
	        }
	      
            let picker = $("#"+this.pickerId);
	        let start = moment();
	        let end = moment();

	        let self = this;

	        function cb(xstart, xend, label) {
	            var title = '';
	            var range = '';

	            if ((xend - xstart) < 100 || label == 'Hôm nay') {
	                title = 'Hôm nay:';
	                range = xstart.format('DD/MM/Y');
	            } else if (label == 'Hôm qua') {
	                title = 'Hôm qua:';
	                range = xstart.format('DD/MM/Y');
	            } else if(xstart.format('DD/MM/Y') == xend.format('DD/MM/Y')){
	            	title = 'Ngày:';
	            	range = xstart.format('DD/MM/Y');
	            }
	            else {
	                range = xstart.format('DD/MM/Y') + ' - ' + xend.format('DD/MM/Y');
	            }

	            picker.find('.m-subheader__daterange-date').html(range);
	            picker.find('.m-subheader__daterange-title').html(title);

	            self.$emit('date-change', xstart.format('Y-MM-DD'), xend.format('Y-MM-DD'));
	        }

	        picker.daterangepicker({
	            startDate: start,
	            endDate: end,
				opens: 'right',
	            ranges: {
	                'Hôm nay': [moment(), moment()],
	                'Hôm qua': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
	                'Tuần này': [moment().startOf('isoWeek'), moment()],
	                'Tuần trước': [moment().startOf('isoWeek').subtract(1,"weeks"), moment().startOf('isoWeek').subtract(1, 'days')],
	                'Tháng này': [moment().startOf('month'), moment()],
	                'Tháng trước': [moment().startOf('month').subtract(1,"M"), moment().startOf('month').subtract(1, 'days')],
				},
				locale: {
					applyLabel: "Chọn",
					cancelLabel: "Xóa",
					customRangeLabel: "Ngày tùy chọn"
				}
	        }, cb);

	        cb(start, end, '');
        }
    }
}

</script>